module.exports = __webpack_public_path__ + "33c457fa945492bc68f9d1a95516d53d.svg";